import type { JSX } from 'react';
import type { ColumnDef, FilterState, FilterValue } from '@/shared/types/table-filters.types';
import { TableFilterControl } from './TableFilterControl';

export interface TableFilterPanelProps<T> {
  columns: ColumnDef<T>[];
  filters: FilterState;
  scope: string;
  className?: string;
  onFilterChange: (key: string, value: FilterValue | undefined) => void;
}

/** The set of filter controls, laid out by the caller (inline row or sheet column). */
export function TableFilterPanel<T>({
  columns,
  filters,
  scope,
  className,
  onFilterChange,
}: TableFilterPanelProps<T>): JSX.Element {
  return (
    <div className={className}>
      {columns.map((column) => (
        <TableFilterControl
          key={column.key}
          column={column}
          scope={scope}
          value={filters[column.key]}
          onChange={(value) => onFilterChange(column.key, value)}
        />
      ))}
    </div>
  );
}
